<div class="main-container">
  <div class="banner-content">
    <h1 class="title">
      {{ "REGISTER.TWO_STEP_VERIFICATION.TITLE" | translate }}
    </h1>
    <div class="description-container">
      <p class="description">
        {{ "REGISTER.TWO_STEP_VERIFICATION.DESCRIPTION" | translate }}
      </p>
      <p class="description">
        {{ "REGISTER.TWO_STEP_VERIFICATION.DESCRIPTION_2" | translate }}
        <b>{{
          "REGISTER.TWO_STEP_VERIFICATION.DESCRIPTION_BOLD" | translate
        }}</b>
        {{ "REGISTER.TWO_STEP_VERIFICATION.DESCRIPTION_3" | translate }}
      </p>
    </div>
  </div>

  <button
    cari-button
    class="two-step-button"
    data-size="small"
    data-type="action"
    type="button"
    (click)="openTwoStepVerificaitonModal()"
  >
    {{ "REGISTER.TWO_STEP_VERIFICATION.BUTTON" | translate }}
  </button>
</div>
